import React from 'react';
import FormGroupTextInput from "../formGroupTextInput";
import Dropzone from 'react-dropzone'
import FormGroupPlainText from "../formGroupPlainText";
import Button from "../button";
import InfoLabel from "../infoLabel";
import 'string.prototype.startswith';
import '../../style/articleForm.css'
import FormResponseMessage from "../formResponseMessage";
import '../../style/dots.css';
import Dots from 'react-activity/lib/Dots';
import _ from 'lodash';
import GeneralSVG from "../generalSVG";
import CustomEditor from "../General/CustomEditor";
import {DROPZONE_ACCEPTED_FILES} from "../../helpers/variables";

const ArticleForm = (props) => {
    const colorStyleMap = {
        BACKGROUNDCOLOR: {
            "backgroundColor": "rgb(255, 212, 2)"
        }
    };
    return (
        <div className="row">
            <div className="col-sm-12">
                <h2 className="solicitor-form-title">
                    {
                        props.edit ?
                            <span>Edit Article</span>
                            :
                            <span>New Article</span>
                    }
                </h2>
                <form className="form-horizontal" onSubmit={(evt) => props.handleSubmit(evt)}>
                    <FormGroupTextInput
                        InputWrapper="col-sm-6 formGroup-textInput-input-wrapper"
                        Label="Title"
                        Required={true}
                        Name="title"
                        Type="text"
                        HandleInputChange={props.changeArticleFormSettings}
                        Value={props.articleForm.title}
                    />
                    <div className="form-group">
                        <div className="col-sm-3">
                            <label className="control-label.text-left formGroup-textInput-label">
                                Body<span>{' '}*</span>
                            </label>
                        </div>
                        <div className="col-sm-6  formGroupTextArea-wrapper">
                            <CustomEditor
                                value={props.articleForm.articleBody}
                                onEditorChange={(content) => {
                                    props.changeArticleFormSettings('articleBody', content);
                                }}
                            />
                        </div>
                        <div className="col-sm-2">
                            <InfoLabel
                                Value="Fill the body of the article."
                                infoState={props.articleForm.infoState.body} Name="body"
                                onMouseOverHandler={props.changeArticleFormInfoState}/>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="col-sm-3">
                            <label className="control-label.text-left formGroup-textInput-label">
                                Upload File
                            </label>
                        </div>
                        <div className="col-sm-6 updateTab-dropzone-wrapper">
                            <div className="col-xs-8 updateTab-upload-label-wrapper">
                                <Dropzone onDropAccepted={props.onDrop} accept={DROPZONE_ACCEPTED_FILES}
                                          multiple={true}
                                          className="formGroup-textInput-input newApplication-upload-element ">
                                    <p className="longWordBreak">Drag and drop.</p>
                                </Dropzone>
                            </div>
                            <div className="col-xs-4 updateTab-upload-button-wrapper longWordBreak">
                                <Dropzone onDropAccepted={props.onDrop} accept={DROPZONE_ACCEPTED_FILES}
                                          multiple={true}
                                          className="updateTab-upload-wrapper newApplication-upload-element ">
                                    <p>Choose File</p>
                                </Dropzone>
                                <svg className="updateTab-upload-arrow" xmlns="http://www.w3.org/2000/svg"
                                     viewBox="0 0 9.6 16"><title>Asset 2</title>
                                    <g id="Layer_2" data-name="Layer 2">
                                        <g id="Layer_1-2" data-name="Layer 1">
                                            <path
                                                d="M9.6,8.08a1.63,1.63,0,0,1-.48,1.16L2.81,15.53A1.63,1.63,0,0,1,.52,13.21L5.68,8.07.47,2.78A1.63,1.63,0,1,1,2.78.49L9.13,6.94A1.63,1.63,0,0,1,9.6,8.08Z"/>
                                        </g>
                                    </g>
                                </svg>
                            </div>
                        </div>
                        <div className="col-sm-2">
                            <InfoLabel
                                Value="Upload File(s)."
                                infoState={props.articleForm.infoState.upload} Name="upload"
                                onMouseOverHandler={props.changeArticleFormInfoState}
                            />
                        </div>
                    </div>
                    <FormGroupPlainText
                        RightWrapper="col-sm-2"
                        rightData={<InfoLabel
                            Value="Check if you want the article to be published and be visible."
                            infoState={props.articleForm.infoState.live} Name="live"
                            onMouseOverHandler={props.changeArticleFormInfoState}/>}
                        LeftWrapper="col-sm-3"
                        Label="Publish"
                        InputWrapper="manageSolicitorAccount-data col-sm-6"
                        Text={<div>
                            <input id="live"
                                   onChange={() => props.changeArticleFormSettings('live', !props.articleForm.live)}
                                   checked={props.articleForm.live}
                                   type="checkbox"
                                   className="appFormRefSettings-check_box"
                                   name="live"
                            />
                            <label htmlFor="live"></label>
                        </div>}
                    />
                    <div className="form-group">
                        <div className="col-sm-6 col-sm-offset-3">
                            <Button wrapper="btn-wrapper-forForms" btnType="submit"
                                    btnStyle={'btn btn-primary btn-xs sharp yellow'}
                                    label={props.edit ? "Save Changes" : "Save New Article"}/>
                            <Button
                                clickHandler={() => props.goBack()}
                                wrapper="btn-wrapper-forForms" btnType="button"
                                btnStyle={'btn btn-primary btn-xs sharp white'}
                                label="Cancel"/>
                        </div>
                    </div>
                    {
                        props.articleForm.postSuccessMsg !== '' ?
                            <FormResponseMessage
                                LeftWrapper="col-sm-3"
                                CenterWrapper="col-sm-6"
                                MessageStyle="formResponseMessage-success"
                                Message={props.articleForm.postSuccessMsg}/>
                            :
                            null
                    }
                    {
                        props.articleForm.errorMsg !== '' ?
                            <FormResponseMessage
                                LeftWrapper="col-sm-3"
                                CenterWrapper="col-sm-6 formGroupTextArea-wrapper"
                                MessageStyle="formResponseMessage-reject"
                                Message={props.articleForm.errorMsg}
                            />
                            :
                            null
                    }
                    <div className="form-group">
                        <div className="col-sm-6 col-sm-offset-3">
                            <ul className="newApplication-attachment-list">
                                {props.articleForm.attachments.length > 0 ?
                                    props.articleForm.attachments.map((attachments, index) => {
                                        return <li key={index}>
                                            <div className="row">
                                                <div className="col-sm-12 attachment-remove__wrapper">
                                                    <div
                                                        className="attachment-remove"
                                                        onClick={() => props.articleFormAttachmentRemove(index)}>X
                                                    </div>
                                                    {'  '}
                                                    {attachments.name}
                                                </div>
                                            </div>
                                        </li>
                                    })
                                    :
                                    null
                                }
                            </ul>
                            {
                                props.articleForm.fetchedArticleAttachments.length > 0 ?
                                    <div>
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <hr className="appFormRefSettings-hr"/>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <h4 className="col-sm-12 ">Files Already Attached.</h4>
                                        </div>
                                        <ul className="newApplication-attachment-list">
                                            {
                                                props.articleForm.fetchedArticleAttachments.map((attachments, index) => {
                                                    return <li key={index}>
                                                        <div className="row">
                                                            <div className="col-sm-12 attachment-remove__wrapper">
                                                                <div
                                                                    className="attachment-remove"
                                                                    onClick={
                                                                        () => props.changeArticleFormSettings('fetchedArticleAttachments', _.filter(props.articleForm.fetchedArticleAttachments, (attachment) => {
                                                                            return attachment.id !== attachments.id
                                                                        }))
                                                                    }>X
                                                                </div>
                                                                {'  '}
                                                                <a onClick={() => props.requestGetArticleAttachment({articleId:props.articleForm.id,attachmentId:attachments.id})}
                                                                   className="applicationPolicy-document-tab-link">
                                                                    <GeneralSVG
                                                                        SvgWrapper="generalTab-download-wrapper inlineBlock"
                                                                        Label="Download"
                                                                        Svg={<svg xmlns="http://www.w3.org/2000/svg"
                                                                                  viewBox="0 0 10 10"><title>Asset
                                                                            9</title>
                                                                            <g id="Layer_2" data-name="Layer 2">
                                                                                <g id="info">
                                                                                    <path
                                                                                        d="M9.5,6a.5.5,0,0,0-.5.5V9H1V6.5a.5.5,0,0,0-1,0V10H10V6.5A.5.5,0,0,0,9.5,6Z"/>
                                                                                    <path
                                                                                        d="M5,7.21,7.35,4.85a.5.5,0,0,0-.71-.71L5.5,5.29V0h-1V5.29L3.35,4.15a.5.5,0,0,0-.71.71Z"/>
                                                                                </g>
                                                                            </g>
                                                                        </svg>}
                                                                    />
                                                                </a>
                                                                {' ' + attachments.name}
                                                            </div>
                                                        </div>
                                                    </li>
                                                })
                                            }
                                        </ul>
                                    </div>
                                    :
                                    null
                            }
                        </div>
                    </div>
                    {
                        props.articleForm.posting || (props.articleForm.patching) ?
                            <div className="form-group">
                                <div className="col-sm-3"></div>
                                <div className="col-sm-6">
                                    <div className="col-sm-5"></div>
                                    <Dots/>
                                </div>
                            </div>
                            :
                            null
                    }
                </form>
            </div>
        </div>
    )
};

export default ArticleForm;